import React from "react";
import MUIDataTable from "mui-datatables";

import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";

import axios from "axios";
import CircularProgress from "@material-ui/core/CircularProgress";

import Button from "@material-ui/core/Button";
import Fab from "@material-ui/core/Fab";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import ViewIcon from "@material-ui/icons/Visibility";
import HistoryIcon from "@material-ui/icons/History";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";

import api from "../common/api";
import History from "../common/vehicles/History";

class ACVehicles extends React.Component {
  constructor() {
    super();

    this.state = {
      vehicles: [],
      isLoaded: false,
      defaultState: "",
      history_dialog: { open: false, plate: "" }
    };
  }

  componentDidMount() {
    this.getAcVehicles();
  }

  getAcVehicles = async () => {
    const token = localStorage.getItem("userToken");
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get("state")) {
      this.setState({ defaultState: searchParams.get("state") });
    }

    return axios
      .get(api.vehicles().indexAc(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({ isLoaded: true, vehicles: res.data });
      })
      .catch(err => {
        this.setState({ isLoaded: true, vehicles: [] });
      });
  };

  handleHistoryDialog = (e, plate) => {
    var history_dialog = this.state.history_dialog;
    history_dialog.plate = plate;
    history_dialog.open = !history_dialog.open;
    this.setState({ history_dialog });
  };

  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: "4px 8px 4px 8px",
            fontSize: "0.75rem"
          }
        }
      }
    });

  render() {
    const columns = [
      {
        name: "id",
        label: "Id",
        options: {
          filter: false,
          sort: true,
          display: false
        }
      },
      {
        name: "plate",
        label: "Patente",
        options: {
          filter: true,
          filterType: "textField",
          sort: true
        }
      },
      {
        name: "description",
        label: "Descripción",
        options: {
          filter: true,
          filterType: "textField",
          sort: true
        }
      },
      {
        name: "state.name",
        label: "Estado",
        options: {
          filter: true,
          filterType: "dropdown",
          filterList: [
            this.state.defaultState ? this.state.defaultState : "DISPONIBLE"
          ],
          sort: false
        }
      },
      {
        name: "active_booking",
        label: "Reserva",
        options: {
          filter: true,
          filterType: "textField",
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            if (!value) return "";
            if (value && value[0]) return value[0].hansa_code;
            return "Sin reserva";
          }
        }
      },
      {
        name: "vehicle_color.name",
        label: "Color",
        options: {
          filter: true,
          filterType: "dropdown",
          sort: false
        }
      },
      {
        name: "year",
        label: "Año",
        options: {
          filter: true,
          filterType: "textField",
          sort: false,
          display: false
        }
      },
      {
        name: "last_km",
        label: "KM",
        options: {
          filter: false,
          sort: false,
          display: false
        }
      },
      {
        name: "version.transmition.name",
        label: "Tipo de transmisión",
        options: {
          filter: true,
          filterType: "dropdown",
          sort: false
        }
      },
      {
        name: "version.vehicle_type.name",
        label: "Tipo de vehículo",
        options: {
          filter: true,
          filterType: "dropdown",
          sort: false,
          display: false
        }
      },
      {
        name: "version.vehicle_type.hansa_code",
        label: "Cod Tipo vehículo",
        options: {
          filter: true,
          filterType: "dropdown",
          sort: false,
          display: false
        }
      },
      {
        name: "version.variation.brand.name",
        label: "Marca",
        options: {
          filter: false,
          sort: false,
          display: false
        }
      },
      {
        name: "version.variation.dnrpa_description",
        label: "Modelo",
        options: {
          filter: false,
          sort: false,
          display: false
        }
      },
      {
        name: "version.name",
        label: "Versión",
        options: {
          filter: false,
          sort: false,
          display: false
        }
      },
      {
        name: "infoauto_price",
        label: "Precio Infoauto",
        options: {
          filter: false,
          sort: false,
          display: false
        }
      },
      {
        name: "infoauto_price_date",
        label: "Fecha Precio Infoauto",
        options: {
          filter: false,
          sort: false,
          display: false
        }
      },
      {
        name: "Acciones",
        label: "",
        options: {
          filter: false,
          sort: false,
          setCellHeaderProps: () => ({ align: "right" }),
          customBodyRender: (value, tableMeta) => {
            const rowId = tableMeta.rowData[0];
            const plate = tableMeta.rowData[1];
            return (
              <div
                className="row"
                style={{
                  display: "inline-table",
                  textAlign: "right",
                  paddingRight: "20px"
                }}
              >
                <Tooltip title="Editar">
                  <Fab
                    color="primary"
                    aria-label="edit"
                    variant="extended"
                    style={{ boxShadow: "none", backgroundColor: "green" }}
                    fontSize="small"
                    className="MuiButtonBase-root MuiFab-sizeSmall mr-1"
                    href={"vehicle/edit/" + rowId}
                  >
                    <EditIcon fontSize="small" />
                  </Fab>
                </Tooltip>
                <Tooltip title="Ver">
                  <Fab
                    color="secondary"
                    aria-label="view"
                    variant="extended"
                    style={{ boxShadow: "none" }}
                    fontSize="small"
                    className="MuiButtonBase-root MuiFab-sizeSmall mr-1"
                    href={"vehicle/" + rowId + "/1"}
                  >
                    <ViewIcon fontSize="small" />
                  </Fab>
                </Tooltip>
                <Tooltip title="Admin precios">
                  <Fab
                    color="primary"
                    aria-label="admin-precios"
                    variant="extended"
                    style={{ boxShadow: "none" }}
                    fontSize="small"
                    className="MuiButtonBase-root MuiFab-sizeSmall mr-1"
                    href={"vehicle/" + rowId + "/pricing-history"}
                  >
                    <AttachMoneyIcon fontSize="small" />
                  </Fab>
                </Tooltip>
                <Tooltip title="Historial">
                  <Fab
                    color="primary"
                    aria-label="history"
                    variant="extended"
                    style={{ boxShadow: "none" }}
                    fontSize="small"
                    className="MuiButtonBase-root MuiFab-sizeSmall mr-1"
                    onClick={e => {
                      this.handleHistoryDialog(e, plate);
                    }}
                  >
                    <HistoryIcon fontSize="small" />
                  </Fab>
                </Tooltip>
              </div>
            );
          }
        }
      }
    ];

    const options = {
      filter: true,
      selectableRows: false,
      filterType: "dropdown",
      responsive: "stacked",
      rowsPerPage: 100,

      textLabels: {
        body: {
          noMatch: this.state.isLoaded ? (
            "No hay resultados"
          ) : (
            <CircularProgress />
          ),
          toolTip: "Ordenar",
          columnHeaderTooltip: column => `Ordenar para ${column.label}`
        },
        filter: {
          all: "Todos los resultados",
          title: "Tus filtros",
          reset: "Resetear"
        },
        toolbar: {
          search: "Buscar",
          downloadCsv: "Exportar CSV",
          print: "Imprimir",
          viewColumns: "ver columnas",
          filterTable: "Filtros"
        },
        pagination: {
          next: "Siguiente",
          previous: "Anteior",
          rowsPerPage: "Cantidad por página:",
          displayRows: "de"
        },
        selectedRows: {
          text: "fila(s) seleccionadas"
        }
      }
    };

    return (
      <div>
        <History
          plate={this.state.history_dialog.plate}
          open={this.state.history_dialog.open}
          handleHistoryDialog={this.handleHistoryDialog}
        />
        <MuiThemeProvider theme={this.getMuiTheme()}>
          <MUIDataTable
            title={`Lista de Vehículos`}
            data={Object.values(this.state.vehicles)}
            columns={columns}
            options={options}
          />
        </MuiThemeProvider>
        <div style={{ textAlign: "right" }}>
          <Button
            variant="contained"
            className="mt-3 ml-1 mr-1"
            color="secondary"
            href={"/contracts"}
          >
            Volver
          </Button>
        </div>
      </div>
    );
  }
}

export default ACVehicles;
